import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import {
    GetAllRoster,
    DeleteRoster
} from "adminApi/DutyRosterApi/RosterApi";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import feilds from "../../json/RosterFields.json";
import { FilterStatus } from "utils/FilterStatus";

const RostersTable = () => {
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];
    const { tabledata } = feilds

    // Fetch Hook
    const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAllRoster, {
        page,
        limit,
        search: debouncedSearch,
        title: "Duty Roster",
    });

    const displayFields = generateDisplayFields(tabledata);
    const filterdata = FilterStatus(data);

    // Table Hook
    const { formattedData, columns } = useTableConfig({
        data: filterdata,
        page,
        limit,
        canShowAction,
        refetch,
        IsEdit: false,
        isView: false,
        config: {
            entityName: "Duty Roster",
            editUrl: "edit-roster",
            idKey: "roster_id",
            deleteApi: DeleteRoster,
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const onPageChange = (p) => setPage(p);
    
    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
                fileName: "Roster List",
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch: handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange,
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange,
            }}
        />
    );
};

export default RostersTable;
